import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { openReportById } from '../../scenes/Gnosus/scenes/Report/actions'
import { openLinkagesById } from '../../scenes/Gnosus/scenes/Linkages/actions'
import { addToFavourites } from '../../scenes/Gnosus/components/EntityStack/components/StackContent/components/FavouritesContent/actions'
import { setupDistraintsById } from '../../scenes/Gnosus/scenes/Distraints/actions'

function mapStateToProps(state) {
    return {
        favourites: state.getIn(['ui', 'entityStack', 'favourites', 'entities']),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            addToFavourites,
            openReportById,
            openLinkagesById,
            setupDistraintsById,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
